// extracted by mini-css-extract-plugin
module.exports = {"container":"colorDots_container__3nE4H","dot":"colorDots_dot__3oskX","extra":"colorDots_extra__KlQiv"};